// extracted by mini-css-extract-plugin
export default {"mailFormWrapper":"MailForm_mailFormWrapper__6wo3J","inputContainer":"MailForm_inputContainer__2vwjn","button":"MailForm_button__ssTG6"};